import { SUBSCRIPTION } from '../../Actions/Subscription/types';

export const initialState = {
  subscriptionList: [],
  isLoading: false,
  notificationCount: 0,
  subscriptionInfo: {},
  GE2CExpired: false,
  C2CExpired: false,
  AdhocExpired: false,
  bothExpired: false,
  isSingleSubs: true,
  activeConfigList: {
    isEducationActive: false,
    isCollaborationActive: false,
    isAdhocActive: false
  },
  d: '/',
  c: [],
  isForbidden: false,
  noSubscriptionActive: false
}

const subscriptionReducer = (state = initialState, action) => { //NOSONAR
  switch (action.type) {
    case SUBSCRIPTION.GET_SUBSCRIPTION: {
      return {
        ...state,
        isLoading: state.subscriptionList && state.subscriptionList.length > 0 ? false : true,
      }
    }

    case SUBSCRIPTION.GET_SUBSCRIPTION_SUCCESS: {
      let { subscriptionList, notificationCount } = action;
      return {
        ...state,
        subscriptionList,
        isLoading: false,
        notificationCount
      }
    }
    case SUBSCRIPTION.GET_SUBSCRIPTION_VIEWED: {
      return {
        ...state,
        notificationCount: 0
      }
    }
    case SUBSCRIPTION.GET_SUBSCRIPTION_FAILURE: {
      let { subscriptionError } = action;
      return {
        ...state,
        subscriptionError,
        isLoading: false
      }
    }

    case SUBSCRIPTION.GET_SUBSCRIPTION_INFO_SUCCESS: {
      let { subscriptionInfo } = action;
      return {
        ...state,
        subscriptionInfo,
        isLoading: false
      }
    }
    case SUBSCRIPTION.SET_EXPIRED_STATUS: {
      let { c2c, adhoc, isSingleSubs } = action;
      return {
        ...state,
        C2CExpired: c2c,
        AdhocExpired: adhoc,
        bothExpired: c2c,
        isSingleSubs
      }
    }
    case SUBSCRIPTION.SET_USER_DETAILS: {
      let { b, adhoc, activeConfigList, c, d } = action;
      return {
        ...state,
        b, adhoc, activeConfigList, c, d
      }
    }

    case SUBSCRIPTION.FORBIDDEN_ACCESS: {
      return {
        ...state,
        isForbidden: true
      }
    }

    case SUBSCRIPTION.NO_ACTIVE_SUBS: {
      return {
        ...state,
        noSubscriptionActive: true
      }
    }

    default:
      return state
  }
}

export default subscriptionReducer;